// extracted by mini-css-extract-plugin
module.exports = {"container":"CountDown_container__3jHtV","small":"CountDown_small__1kLH9","valueContainer":"CountDown_valueContainer__2t7xm","units":"CountDown_units__2FDVI"};